<template>
  <div class="orderContent">
    <a-radio-group
      v-model:value="submitParams.confirmed"
      style="margin-bottom: 20px"
      name="radioGroup"
      @change="radioChange"
    >
      <a-radio :value="true">修改状态为已确认</a-radio>
      <a-radio :value="false">修改复诊信息</a-radio>
    </a-radio-group>
    <div v-if="submitParams.confirmed === false" class="remind">
      请分别与医生、患者确认时间再填写
    </div>
    <RetreatForm ref="reFormRef" v-if="submitParams.confirmed === false" />
  </div>
</template>

<script setup>
import { ref, reactive, defineExpose, defineProps, computed, createVNode } from 'vue'
import RetreatForm from './retreatForm.vue'
import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

const prop = defineProps({
  workOrderGroupInfo: {
    type: Object,
    default: () => {}
  }
})
// 是否为患者
const handleType = computed(
  () => prop.workOrderGroupInfo.targetWorkOrder.quickDealNavigationRelationAccountType === 1
)
const submitParams = reactive({
  confirmed: null
})
const mainformValid = () => {
  return new Promise((resolve, reject) => {
    if (submitParams.confirmed === null) {
      reject()
    }
    resolve(submitParams)
  })
}
const reFormRef = ref()
const submitForm = () => {
  if (!reFormRef.value) return {}
  return reFormRef.value.submitValidQuery()
}

const radioChange = e => {
  if (e.target.value && handleType.value) {
    Modal.confirm({
      centered: true,
      title: '提示',
      icon: createVNode(ExclamationCircleOutlined),
      content: '已跟患者沟通并确定？确定后系统将生成正式的复诊日期单，不再与医患进行确认。',
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        submitParams.confirmed = true
      },
      onCancel() {
        submitParams.confirmed = null
      }
    })
  }
}
defineExpose({
  submitForm,
  mainformValid
})
</script>
<style lang="scss" scoped>
@import './normalizeOrder.scss';
</style>
